export default __webpack_public_path__ + "static/media/Spectral-Regular.d42b6921.ttf";